import { EnvironmentOutlined } from '@ant-design/icons';
import { type IAddress } from '@mahawi/eshop-common/src/types';
import React from 'react';

import { COLOR } from '../theme/tokens';

export default function GoogleMapsButton({
  address,
}: {
  address: IAddress;
}): React.ReactElement {
  const streetLine: string = [address.street, address.streetNumber]
    .filter(Boolean)
    .join(' ');
  const url: string = `https://www.google.com/maps/search/${encodeURIComponent(
    [streetLine, address.city, address.zip, address.countryTypeIsoCode]
      .filter(Boolean)
      .join(', '),
  )}`;

  return (
    <EnvironmentOutlined
      style={{ color: COLOR.locationPin }}
      onClick={(): void => {
        window.open(url, '_blank', 'noopener,noreferrer');
      }}
    />
  );
}
